import type { IncentiveRow } from "./IncentiveRow";

export const ROW_KIND = {
	EVENT: "EVENT",
	RECONCILIATION: "RECONCILIATION",
} as const;

export type ShiftIncentiveEventRowKind =
	(typeof ROW_KIND)[keyof typeof ROW_KIND];

export interface ShiftIncentiveEventSnapshotRow {
	RowKind: ShiftIncentiveEventRowKind;
	ShiftId: number;
	ShiftIncentiveEventId: number | null;
	ShiftIncentiveId: number | null;
	EventId: number | null;
	EventTypeCode: string | null;
	SectionId: number | null;
	SectionName: string | null;
	TargetTPH: number | null;
	TargetTPHPct: number | null;
	EffectiveTPH: number | null;
	EventStart: Date | null;
	EventEnd: Date | null;
	OverlapStart: Date | null;
	OverlapEnd: Date | null;
	ScheduledHours: number | null;
	ActualHours: number | null;
	TargetTons: number | null;
	FinishedTons: number | null;
}

export type IncentiveRowWithEventSnapshots = IncentiveRow & {
	hasEventSnapshots: boolean;
	eventSnapshots: ShiftIncentiveEventSnapshotRow[];
};
